import request from '@/utils/request'

// 登录方法
export function login(form) {
  return request({
    url: '/api-uaa/oauth/token',
    method: 'post',
    headers: {
      CONTENT: 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: "Basic "+ window.btoa("webApp:webApp")
    },
    data: form
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api-admin/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/api-uaa/oauth/remove/token',
    method: 'post'
  })
}
